
// Libs
import sptk from '../../libs/sptk';
import Filter from '../classes/Filter';

class RessourcesFilterModule {
    constructor() {
        // ES6 Rebind

        this.initialize();
    }

    initialize() {
        this.bindUI();

        this.filters = [];

        this.initFilters();

    }

    bindUI() {
        this.ui = {};

        this.ui.$ressourcesFilters = document.querySelectorAll('.js-ressources-filter');
    }

    initFilters() {
        [].forEach.call(this.ui.$ressourcesFilters, (item) => {
            this.filters.push(new Filter({
                el: item
            }));
        });
    }

}

export default RessourcesFilterModule;
